import TipTapMention from '@tiptap/extension-mention';

const MentionExtension = TipTapMention.configure({
  renderHTML({ node }) {
    return node.attrs.label ?? node.attrs.id;
  },
});

export default MentionExtension;
